export default __webpack_public_path__ + "static/media/harbinger_of_dawn.26da0d78.png";